import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { ErrorHandlerService } from './error-handler.service';
import { PagingResponse } from '@models/paging-response.model';
import { Custodian } from '../models/review/custodian.model';

@Injectable({
	providedIn: 'root'
})
export class CustodianService {

	constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

	public getCustodians(): Observable<Custodian[]> {
		return this.http.get<Custodian[]>(`${this.appConfigService.getConfig().webApi}/api2/Custodians/Include-Unassigned`)
			.pipe(catchError(this.errorHandler.handleError<Custodian[]>(`get custodians`)));
	}

	public getCustodiansWithSearch(searchTerm?: string): Observable<PagingResponse<Custodian>> {
		return this.http.get<PagingResponse<Custodian>>(`${this.appConfigService.getConfig().webApi}/api2/Custodians`,
			{ params: this.setCustodianQuery(searchTerm) })
			.pipe(catchError(this.errorHandler.handleError<PagingResponse<Custodian>>(`getCustodians with searchTerm=${searchTerm}`)));
	}

	public getCustodianAffiliation(): Observable<string[]> {
		return this.http.get<string[]>(`${this.appConfigService.getConfig().webApi}/api2/Custodians/Affiliation`)
			.pipe(catchError(this.errorHandler.handleError<string[]>(`get custodian affiliation`)));
	}

	public addNewCustodian(custodian: Custodian): Observable<Custodian> {
		return this.http.post<Custodian>(`${this.appConfigService.getConfig().webApi}/api2/Custodians`, custodian)
			.pipe(catchError(this.errorHandler.handleError<Custodian>(`post custodian failed`)));
	}

	public updateCustodian(custodianId: string, custodianDelta): Observable<void> {
		const body = [];
		for (const key in custodianDelta) {
			body.push({
				op: "replace",
				path: `/${key}`,
				value: custodianDelta[key]
			})
		}
		return this.http.patch<void>(`${this.appConfigService.getConfig().webApi}/api2/Custodians/${custodianId}`, body).pipe(
			catchError(this.errorHandler.handleError<void>(`patch custodian failed for custodianId=${custodianId}`)));
	}

	public deleteCustodian(custodianId: string): Observable<void> {
		return this.http.delete<void>(`${this.appConfigService.getConfig().webApi}/api2/Custodians/${custodianId}`)
			.pipe(catchError(this.errorHandler.handleError<void>(`delete custodian failed for custodianId=${custodianId}`)));
	}

	private setCustodianQuery(searchTerm: string): HttpParams {
		const params: HttpParams = new HttpParams();

		if (!searchTerm)
			return params;

		return params.set('$search', `${searchTerm.toLowerCase()}`)
	}
}
